import { useAppSelector } from "../../store";
import { WindowSizeType } from "../../store/slices/layout/layout.types";

const useWindowSize = (): WindowSizeType => {
    return useAppSelector<WindowSizeType>((state) => state.layout.windowSizeType);
};
  
export default useWindowSize;